export const SPIRIT_KEYWORDS = [
  "whisky",
  "whiskey",
  "gin",
  "vodka",
  "brandy",
  "rum",
  "tequila",
  "cognac",
  "sake",
  "mezcal",
  "agave",
  "spirits",
  "liqueur",
  "cocktail",
  "scotch",
  "whiskymofo",
];

const vmWmSiteName = process.env.GATSBY_VM_WM_SITE_NAME;
const vmWmAppUrl = vmWmSiteName ? process.env.GATSBY_VM_WM_APP_URL : "";

export const isWhiskymofo = process.env.GATSBY_VM_WM_SITE_NAME === "WM";

export const isVinomofo = process.env.GATSBY_VM_WM_SITE_NAME === "VM";

export const isAuMarket = process.env.GATSBY_VM_MARKET === "AU";

export const isSgMarket = process.env.GATSBY_VM_MARKET === "SG";

export const brand = isSgMarket ? "VM" : isWhiskymofo ? "WM" : "VM";

export const hasSpiritsInPath = (pathname?: string): boolean => {
  if (!pathname) return false;

  const lowerPath = pathname.toLowerCase();

  return SPIRIT_KEYWORDS.some((keyword) => {
    const regex = new RegExp(`\\b${keyword.toLowerCase()}\\b`);
    return regex.test(lowerPath);
  });
};

export const isVinoArticlePage = (pathname?: string): boolean => {
  return pathname?.toLowerCase().includes("/vino-articles/") || false;
};

export const isWhiskymofoSignupPage = (pathname?: string): boolean => {
  return (isWhiskymofo && pathname === "/") || false;
};

export const isWhiskymofoDealsPage = (pathname?: string): boolean => {
  return pathname?.toLowerCase().includes("/deals") || false;
};

export const getBaseUrl = (isSpirit: boolean): string => {
  const currentSiteUrl = process.env.GATSBY_APP_URL || "";

  if (!vmWmAppUrl) {
    return currentSiteUrl;
  }

  const shouldUseCrossSiteUrl =
    (isVinomofo && isSpirit) || (isWhiskymofo && !isSpirit);

  return shouldUseCrossSiteUrl ? vmWmAppUrl : currentSiteUrl;
};
